import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { Alert, Card } from '@mui/material';
import getSymbolFromCurrency from 'currency-symbol-map';
import React, { useEffect, useState } from 'react';
import AxiosConfig from '../../../../../../../config/AxiosConfig';
import { RefundFormDetails } from './RefundDetails.jsx';
import { RefundDocumentUploader } from './RefundDocumentUploader.jsx';
import { RefundFormActions } from './RefundFormAction.jsx';
import { RefundFormInputs } from './RefundFormInputs.jsx';
import { RefundFormMarketplace } from './RefundFormMP.jsx';
import { RefundFormSummary } from './RefundFormSummary.jsx';
import { RefundReasonSelect } from './RefundReason.jsx';

export const RefundForm = ({
  ticket,
  isOlderThanSixMonths,
  mutateTicket,
  handleShowComponent,
  order,
}) => {
  console.log('order', order?.dates?.createdAt);
  console.log('ticket', ticket?.order?.dates?.createdAt);
  const [formState, setFormState] = useState({
    demand: 'Remboursement',
    firstName: ticket?.contact?.firstName || '',
    lastName: ticket?.contact?.lastName || '',
    email: ticket?.contact?.email || '',
    orderRef: ticket?.order?.reference || '',
    orderedAt: ticket?.order?.dates?.createdAt
      ? new Date(ticket?.order?.dates?.createdAt)
      : null,
    paymentMethod: ticket?.order?.paymentMethod || '',
    total: ticket?.order?.price || 0,
    refundAmount: 0,
    refundPercentage: 0,
    desc: '',
    selectedType: {},
    isMP: ticket?.isFromMP || false,
    marketplace: ticket?.isFromMP ? ticket?.contact?.store?.seller : '',
    isOrderedAtFieldProvided: Boolean(ticket?.order?.dates?.createdAt),
    isPaymentMethodFieldProvided: ticket?.order?.paymentMethod ? true : false,
    rib: null,
  });

  const [errorFormState, setErrorFormState] = useState({});

  useEffect(() => {
    isErrorOnFields();
  }, [formState]);

  const isErrorOnFields = () => {
    const fieldsToCheck = [
      { name: 'selectedType._id', value: formState?.selectedType?._id },
      { name: 'lastName', value: formState?.lastName?.length },
      { name: 'email', value: formState?.email?.length },
      { name: 'orderRef', value: formState?.orderRef?.length },
      { name: 'paymentMethod', value: formState?.paymentMethod?.length },
      { name: 'total', value: formState?.total > 0 },
      { name: 'refundAmount', value: formState?.refundAmount > 0 },
      { name: 'desc', value: formState?.desc?.length },
      {
        name: 'marketplace.name',
        value: ticket?.isFromMP
          ? formState?.marketplace?.name?.length > 0
          : true,
      },
      {
        name: 'orderedAt',
        value:
          formState?.orderedAt instanceof Date && !isNaN(formState.orderedAt),
      },
      { name: 'demand', value: formState?.demand?.length },
      { name: 'ticket._id', value: ticket?._id },
      {
        name: 'rib',
        value:
          isOlderThanSixMonths && formState.demand === 'Geste commercial'
            ? formState.rib
            : true,
      },
    ];

    const isError = !fieldsToCheck.every(({ value }) => Boolean(value));

    const validateField = (value, errorMessage) => (value ? '' : errorMessage);

    handleErrorChange('isError', isError);
    handleErrorChange('selectedType', !formState.selectedType?._id);

    handleErrorChange(
      'lastName',
      validateField(formState.lastName, 'Veuillez remplir le nom du client')
    );
    handleErrorChange(
      'email',
      validateField(formState.email, 'Veuillez remplir le mail du client')
    );
    handleErrorChange(
      'orderRef',
      validateField(
        formState.orderRef,
        'Veuillez vérifier le numéro de commande'
      )
    );
    handleErrorChange(
      'paymentMethod',
      validateField(
        formState.paymentMethod,
        'Veuillez vérifier le moyen de paiement'
      )
    );
    handleErrorChange(
      'total',
      validateField(formState.total > 0, 'Veuillez vérifier le montant total')
    );
    handleErrorChange(
      'refundAmount',
      validateField(
        formState.refundAmount > 0,
        'Veuillez vérifier le montant à rembourser'
      )
    );
    handleErrorChange(
      'desc',
      validateField(formState.desc, 'Veuillez vérifier le motif')
    );

    handleErrorChange(
      'orderedAt',
      validateField(
        formState.orderedAt instanceof Date && !isNaN(formState.orderedAt),
        'Veuillez sélectionner une date de commande valide'
      )
    );

    if (ticket?.isFromMP) {
      handleErrorChange(
        'marketplace',
        validateField(
          formState.marketplace?.name,
          'Veuillez vérifier le Marketplace'
        )
      );
    }

    if (isOlderThanSixMonths && formState.demand === 'Geste commercial') {
      handleErrorChange(
        'rib',
        validateField(formState.rib, 'Veuillez fournir le RIB du client')
      );
    }
  };

  const handleInputChange = (field, value) => {
    setFormState((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleErrorChange = (field, value) => {
    setErrorFormState((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleFileChange = (file) => {
    setFormState((prev) => ({
      ...prev,
      rib: file,
    }));
  };

  const handleFileRemove = () => {
    setFormState((prev) => ({
      ...prev,
      rib: null,
    }));
  };

  useEffect(() => {
    AxiosConfig.create('get', `/tickets/${ticket?._id}/refund`)
      .call()
      .exit((res) => {
        if (res?.data?.isDraft) {
          setFormState((prev) => ({
            ...prev,
            demand: res.data?.type,
            firstName: res.data?.firstName || '',
            lastName: res.data?.lastName,
            email: res.data?.email,
            orderRef: res?.data?.order?.reference,
            orderedAt: res.data?.orderedAt
              ? new Date(res.data?.orderedAt)
              : null,
            paymentMethod: res.data?.paymentMethod,
            total: res.data?.amountTotal,
            refundAmount: res.data?.amountToRefund,
            refundPercentage:
              (res.data?.amountToRefund / res.data?.amountTotal) * 100,
            desc: res.data?.description,
            selectedType: res.data?.refundType,
            isMP: res.data?.isMP,
            marketplace: res.data?.seller,
            rib: null,
          }));
        }
      })
      .catch((err) => console.error(err));
  }, [ticket]);

  console.log('formState', formState?.orderedAt);

  return (
    <Card
      elevation={5}
      sx={{
        width: '100%',
        padding: 2,
        gap: '1rem',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {order?.amounts?.discount?.code && (
        <Alert
          variant="outlined"
          color="warning"
          sx={{ m: 2 }}
          icon={<LocalOfferIcon />}
        >
          La commande à une réduction appliquée:{' '}
          {order?.amounts?.discount?.code} - {order?.amounts?.discount?.value}
          {' | '}
          {`${order?.amounts?.discount?.amount}${getSymbolFromCurrency(order?.currency?.code)}`}
        </Alert>
      )}
      <RefundFormMarketplace
        isMP={formState.isMP}
        marketplace={formState.marketplace}
        error={errorFormState.marketplace}
        onChange={(value) => handleInputChange('isMP', value)}
      />
      <RefundFormDetails
        demand={formState.demand}
        selectedType={formState.selectedType}
        error={errorFormState.selectedType}
        onTypeChange={(value) => handleInputChange('selectedType', value)}
        onDemandChange={(value) => handleInputChange('demand', value)}
      />
      <RefundFormInputs
        ticket={ticket}
        formState={formState}
        errorFormState={errorFormState}
        onInputChange={handleInputChange}
      />
      <RefundFormSummary
        refundAmount={formState.refundAmount}
        refundPercentage={formState.refundPercentage}
        error={errorFormState.refundAmount}
        onRefundAmountChange={(value) => {
          handleInputChange('refundAmount', value);
          handleInputChange(
            'refundPercentage',
            (value / formState.total) * 100
          );
        }}
        ticket={ticket}
      />
      <RefundReasonSelect
        desc={formState.desc}
        error={errorFormState.desc}
        onRefundReasonChange={(value) => handleInputChange('desc', value)}
      />
      {formState.demand && (
        <RefundDocumentUploader
          document={formState.rib}
          error={errorFormState.rib}
          onFileChange={handleFileChange}
          onFileRemove={handleFileRemove}
        />
      )}
      <RefundFormActions
        ticket={ticket}
        isOlderThanSixMonths={isOlderThanSixMonths}
        formState={formState}
        errorFormState={errorFormState}
        mutateTicket={mutateTicket}
        handleShowComponent={handleShowComponent}
      />
    </Card>
  );
};
